import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function NihssExamination({ nihss, nihssItemScores }) {
  const { t } = useTranslation();

  const getScore = (itemKey) => {
    const score = nihssItemScores?.[itemKey];
    return score == null ? 'N/A' : score;
  };

  const nihssItem = (item, name, itemKey) =>
    item > 0 && (
      <>
        <Grid item xs={8}>
          <Typography>{t(`${name}Title`)}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography sx={{ textAlign: 'right' }}>+ {getScore(itemKey)}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography color="primary" variant="body2">
            {t(`${name}${item}`)}
          </Typography>
        </Grid>
      </>
    );

  const nihss4ItemSide = (item4Val, item, name) =>
    item4Val > 0 && (
      <>
        <Grid item xs={12}>
          <Typography>{t(`${name}Title`)}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography color="primary" variant="body2">
            {t(`${item}`)}
          </Typography>
        </Grid>
      </>
    );

  return (
    nihss && (
      <>
        {nihssItem(nihss.item1A, 'nihss1A', 'item1A')}
        {nihssItem(nihss.item1B, 'nihss1B', 'item1B')}
        {nihssItem(nihss.item1C, 'nihss1C', 'item1C')}
        {nihssItem(nihss.item2, 'nihss2', 'item2')}
        {nihssItem(nihss.item3, 'nihss3', 'item3')}
        {nihssItem(nihss.item4, 'nihss4', 'item4')}
        {nihss4ItemSide(nihss.item4, nihss.item4Side, 'nihss4Side')}
        {nihssItem(nihss.item5A, 'nihss5A', 'item5A')}
        {nihssItem(nihss.item5B, 'nihss5B', 'item5B')}
        {nihssItem(nihss.item6A, 'nihss6A', 'item6A')}
        {nihssItem(nihss.item6B, 'nihss6B', 'item6B')}
        {nihssItem(nihss.item7, 'nihss7', 'item7')}
        {nihssItem(nihss.item8, 'nihss8', 'item8')}
        {nihssItem(nihss.item9, 'nihss9', 'item9')}
        {nihssItem(nihss.item10, 'nihss10', 'item10')}
        {nihssItem(nihss.item11, 'nihss11', 'item11')}
      </>
    )
  );
}
